exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img .profile-post-content img{cursor:-webkit-zoom-in;cursor:zoom-in;width:auto}.el-carousel__item>img{height:inherit}.full-page .link-list-info{background:#fff!important}.ing_post{margin:0;text-align:left;padding-left:50px;padding-bottom:20px;padding-right:50px;max-width:800px;word-break:break-word}.adj_img{padding-right:10px}.toghumImg img{-o-object-fit:contain;object-fit:contain}.toghumImg{padding-top:5px;padding-bottom:5px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1074f5a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/submission/ImgSubmission.vue
// module id = ATh/
// module chunks = 0